import { Button } from '../../../../../../components/Toolkit/Button/Button';
import {
  RevealPhoneNumber,
  type RevealPhoneNumberProps,
} from '../../../../../../components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { Columns } from '../../../../../../components/Toolkit/Columns/Columns';
import { EmailDealerOrSeller } from '../../EmailDealerOrSeller/EmailDealerOrSeller';

import { type EmailDealerOrSellerProps } from '../../EmailDealerOrSeller/EmailDealerOrSeller.typed';

import { useWhatsappAction } from '../subcomponents/useWhatsAppAction';

type Variant2Props = {
  phoneResponse: boolean;
  emailResponse: boolean;
  phoneContactProps: RevealPhoneNumberProps;
  emailSellerProps: EmailDealerOrSellerProps;
  whatsappResponse: boolean;
  adId: number;
  priceEuro?: number | null;
  sellerType?: string;
  sectionName?: string;
  price?: string | null;
};

const Variant2 = (props: Variant2Props) => {
  const {
    emailResponse,
    emailSellerProps,
    phoneResponse,
    phoneContactProps,
    whatsappResponse,
    adId,
    priceEuro,
    sellerType,
    sectionName,
    price,
  } = props;

  const { onWhatsAppButtonClick, isLoading } = useWhatsappAction({
    adId,
    priceEuro,
    sellerType,
    sectionName,
    price,
  });

  return (
    <Columns>
      {emailResponse && (
        <EmailDealerOrSeller
          {...emailSellerProps}
          ofType={phoneResponse || whatsappResponse ? 'SECONDARY' : 'PRIMARY'}
        >
          Email
        </EmailDealerOrSeller>
      )}
      {whatsappResponse && (
        <Button
          ofType={phoneResponse ? 'SECONDARY' : 'PRIMARY'}
          onClick={onWhatsAppButtonClick}
          disabled={isLoading}
        >
          WhatsApp
        </Button>
      )}
      {phoneResponse && (
        <RevealPhoneNumber {...phoneContactProps}>Show phone</RevealPhoneNumber>
      )}
    </Columns>
  );
};

export { Variant2 };
